import { Injectable } from '@angular/core';

import { TmsWebBaseEditService } from '../base';
import { PrintMethod } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class PrintMethodService extends TmsWebBaseEditService<PrintMethod, PrintMethod> {
  constructor() {
    super('PrintMethod', $localize`Print Method`);
  }
}
